import React from "react";
import { LOGIN } from "../../routes";
import { Link, useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import { signup } from "../../Services/loginService";
import * as Yup from "yup";
import { SIGNUP_FIELDS, DEFAULT_USER_ROLE } from "./constants";
import { FloatingInput, Spinner, PinInput } from "../../Components/Common";
import { MESSAGES } from "./constants";
import solarParkImg from "../../Assets/Solar_Park.jpg";
import solarParkImg2 from "../../Assets/Solar_Park2.jpg";
import GreenEn_Logo from "../../Assets/GreenEn_Logo.png"
import { extractErrorMessage } from "../../Utils/extractErrorMessage"

const validationSchema = Yup.object().shape({
  first_name: Yup.string().required("Required"),
  last_name: Yup.string().required("Required"),
  // role: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  password: Yup.string()
    .matches(/^[0-9]+$/, "Only digits are allowed")
    .max(4, "Password must be 4 characters")
    .required("Required"),
  confirmPassword: Yup.string()
    .matches(/^[0-9]+$/, "Only digits are allowed")
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Required"),
  mobile: Yup.string()
    .matches(/^[0-9]+$/, "Only digits are allowed")
    .min(10, "Must be exactly 10 digits")
    .required("Required"),
});

const SignUp = () => {
  const navigate = useNavigate();
  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirmPassword: "",
    role: "",
    mobile: "",
  };

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      let newValues = { ...values, role: DEFAULT_USER_ROLE };
      const response = await signup(newValues);
      if (response.status === 201) {
        toast.success(MESSAGES.SIGN_UP_SUCCESS);
        navigate(LOGIN);
      } else {
        const msg = extractErrorMessage(response) || MESSAGES.SIGN_UP_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      const msg = extractErrorMessage(error) || MESSAGES.SIGN_UP_FAILED;
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="relative flex justify-center items-center md:bg-none px-2 overflow-hidden min-h-[100dvh] min-h-[calc(100dvh-constant(safe-area-inset-bottom))] min-h-[calc(100dvh-env(safe-area-inset-bottom))]">
      {/* Mobile Background */}
      <div
        className="md:hidden absolute inset-0 bg-cover bg-center opacity-50 z-0"
        style={{ backgroundImage: `url(${solarParkImg2})` }}
      ></div>
      {/* Desktop Background */}
      <div
        className="hidden md:block absolute inset-0 bg-cover bg-center opacity-80 z-0"
        style={{ backgroundImage: `url(${solarParkImg})` }}
      ></div>

      <div className="relative z-10 w-full md:w-1/2 p-4 bg-white/80 md:bg-white/90 backdrop-blur-md rounded-md shadow-md">
        <div className="flex items-center justify-center gap-4 mb-2">
          <img
            src={GreenEn_Logo}
            alt="SolarOps Logo"
            className="w-6 h-6 md:w-10 md:h-10 object-contain"
          />
          <h1 className="text-xl md:text-4xl font-semibold text-primary">
            {process.env.REACT_APP_TITLE}
          </h1>
        </div>

        <div className="flex justify-center">
          <h1 className="text-xl font-bold py-2 leading-tight tracking-tight text-secondary">
            Sign Up
          </h1>
        </div>
        <div className="flex flex-col items-center gap-1 rounded-lg">
          <div className="w-full">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ isSubmitting }) => (
                <Form className="space-y-3 w-full">
                  <div className="flex flex-col md:gap-3 w-full">
                    {SIGNUP_FIELDS.map((field) => (
                      <FloatingInput
                        key={field.name}
                        label={field.label}
                        name={field.name}
                        type={field.type}
                        css={field.css}
                        maxLength={field.maxLength}
                      />
                    ))}

                    <div className="flex flex-col md:flex-row gap-3">
                      <div className="w-full md:w-1/2">
                        <PinInput name="password" label="Password" />
                      </div>
                      <div className="w-full md:w-1/2">
                        <PinInput
                          name="confirmPassword"
                          label="Confirm Password"
                        />
                      </div>
                    </div>
                  </div>

                  {/* <div className="items-center flex justify-evenly md:justify-start">
                    <label className="text-sm font-bold text-secondary mr-8">
                      Select Role
                    </label>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-16 items-center w-full">
                      {USER_ROLE_FIELDS.map((field, index) => (
                        <div key={index}>
                          <RadioInput
                            label={field.label}
                            name={field.name}
                            value={field.value}
                          />
                        </div>
                      ))}
                    </div>
                    <ErrorMessage
                      name="role"
                      component="div"
                      className="text-red-500 text-xs"
                    />
                  </div> */}

                  <div className="flex justify-between items-center">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="flex w-full justify-center rounded-md bg-primary mt-4 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-secondary focus:outline-none"
                    >
                      {!isSubmitting ? "Sign up" : <Spinner />}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <p className="text-center text-sm text-secondary mt-3">
            Already a member?{" "}
            <Link
              to={LOGIN}
              className="font-semibold text-primary hover:text-secondary"
            >
              Login Now!
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
